export default __webpack_public_path__ + "static/media/08-Google-Logo.b994ce8f.png";